import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import MaxiSkeleton from 'components/widgets/VideoPlayout/components/MaxiSkeleton/MaxiSkeleton';
import VideoPlayout from 'components/widgets/VideoPlayout/VideoPlayout';
import { globalStorage } from 'services/globalStorage';

function MaxiPlayerViewResolver({ pageReferenceId }: { pageReferenceId: string }) {
  const isVideoPlayoutAllowed = !globalStorage.isDisableMaxiPlayer && !globalStorage.isMaxiLoading;

  useEffect(() => {
    return () => {
      globalStorage.clearIsMaxiLoading();
    };
  }, [pageReferenceId]);

  return (
    <>
      {globalStorage.isMaxiLoading && <MaxiSkeleton />}
      {isVideoPlayoutAllowed ? <VideoPlayout pageReferenceId={pageReferenceId} /> : null}
    </>
  );
}

export default observer(MaxiPlayerViewResolver);
